import React from "react";
import { ReloadOutlined } from '@ant-design/icons';
import { Form, FormInstance, Input, Space, Spin, Tooltip } from "antd";

export interface ICaptchaProps {
    name: string;
    label?: string;
    form: FormInstance;
    showLabel?: boolean;
}

interface ICaptchaState {
    captchaImage?: string;
    forceLoad: boolean;
}

export const Captcha = (props: ICaptchaProps) => {
    const [state, setState] = React.useState<ICaptchaState>({ forceLoad: false });

    //e is React.KeyboardEvent<HTMLInputElement>
    const checkNumberInput = (e: any) => {
        if (e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 27)
            return;
        if (!(e.keyCode >= 96 && e.keyCode <= 105) && !(e.keyCode >= 48 && e.keyCode <= 57)) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const loading = React.useRef(false);

    const componentWillUnmount = React.useRef(false);

    React.useEffect(() => {
        setState({ forceLoad: true });
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    const loadCaptchaImage = async () => {
        if (loading.current)
            return;

        loading.current = true;


        let response = await fetch("api/captcha/get", {
            method: 'POST',
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        let result = await response.json();
        if (componentWillUnmount.current)
            return;

        props.form.resetFields([props.name]);
        loading.current = false;

        const newState = { ...state, forceLoad: false, captchaImage: result.Data };
        setState(newState);
    };

    if (state.forceLoad)
        loadCaptchaImage();

    return (
        <Form.Item
            name={props.name}
            label={props.showLabel ? props.label : ''}
            style={{ textAlign: 'justify' }}
            rules={[
                { required: true, message: 'لطفا متن تصویر را وارد نمایید' },
                { len: 6, message: 'لطفا متن کامل را وارد نمایید' }
            ]}
        >
            <Space direction="vertical"  >
                {
                    loading.current || !state.captchaImage
                        ? <Spin style={{ paddingTop: 20, width: '160px', height: '50px' }} />
                        : <img src={`data:image/jpeg;base64,${state.captchaImage}`} style={{ width: '160px', height: '50px', opacity: 0.7 }} alt="" />
                }
                <Input
                    autoComplete="off"
                    placeholder={props.label}
                    onKeyDown={checkNumberInput}
                    type="text"
                    lang={'en'}
                    maxLength={6}
                    style={{ width: 160 }}
                    suffix={
                        <Tooltip title="بروزرسانی تصویر">
                            <ReloadOutlined
                                disabled={loading.current}
                                spin={loading.current}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setState({ forceLoad: true });
                                }} />
                        </Tooltip>
                    } />
            </Space>
        </Form.Item>
    );
};